import { render } from "./Snack.vue?vue&type=template&id=262194c4"
import script from "./Snack.vue?vue&type=script&lang=js"
export * from "./Snack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__